import { observer } from 'mobx-react';
import React, { FC, useMemo } from 'react';
import { IColProps } from 'src/interfaces';
import { WidgetBase } from 'src/libs/ui-kit/widget-base/WidgetBase';
import { useStore } from 'src/modules/users/hooks/useStore';
import { UserContactsStoreContext } from '../../UserContacts.widget';
import { CreateUserContactModal } from '../modals/CreateUserContactModal';
import { UserContactsTable } from '../tables/UserContactsTable';

export const CustomerContactsWidget: FC<IColProps> = observer((props) => {
  const store = useStore(UserContactsStoreContext);
  const buttons = useMemo(() => [{ title: 'Создать', clickHandler: store.createModal.show }], [store.createModal.show]);

  return (
    <>
      <WidgetBase
        title="Контакты"
        isLoading={store.getIsContactsInitialLoading}
        hasError={store.hasError}
        buttons={buttons}
        col={props.col}>
        <UserContactsTable />
      </WidgetBase>
      <CreateUserContactModal />
    </>
  );
});
